import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  T_AppMobileNumberObj,
  T_HealthInsuranceSlice,
  T_PolicyInsured,
} from "./HealthInsurance_Types";
import { T_BackgroundImage } from "../../globalTypes/GlobalTypes";

const initialState: T_HealthInsuranceSlice = {
  allPolicyDetails: [],
  secondaryAllPolicyDetails: [],
  allPolicyInsuredDetails: [],
  quickActionMenuDetails: [],
  medicalReportsInlineBackFunClicked: false,
  medicalReportDownloaded: false,
  backgroundImages: [],
  shouldOpenMyServicesPopup: false,
};

export const HealthInsuranceSlice = createSlice({
  name: "HealthInsuranceSlice",
  initialState,
  reducers: {
    setHiAllPolicyDetails: (
      state,
      action: PayloadAction<T_AppMobileNumberObj[]>,
    ) => {
      return {
        ...state,
        allPolicyDetails: action.payload,
      };
    },
    setHiSecondaryAllPolicyDetails: (
      state,
      action: PayloadAction<T_AppMobileNumberObj[]>,
    ) => {
      return {
        ...state,
        secondaryAllPolicyDetails: action.payload,
      };
    },
    setHiAllPolicyInsuredDetails: (
      state,
      action: PayloadAction<T_PolicyInsured[]>,
    ) => {
      return {
        ...state,
        allPolicyInsuredDetails: action.payload,
      };
    },
    setQuickActionMenuDetails: (state, action) => {
      return {
        ...state,
        quickActionMenuDetails: action.payload,
      };
    },
    updateMedicalReportInlineFunClicked: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      return {
        ...state,
        medicalReportsInlineBackFunClicked: action.payload,
      };
    },
    updateMedicalReportDownloaded: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        medicalReportDownloaded: action.payload,
      };
    },
    setHiBackgroundImage: (state, action: PayloadAction<T_BackgroundImage>) => {
      const existingBackgroundImages = Array.isArray(state.backgroundImages)
        ? state.backgroundImages
        : [];

      return {
        ...state,
        backgroundImages: [...existingBackgroundImages, action.payload],
      };
    },
    setShouldOpenHiMyServicesPopup: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        shouldOpenMyServicesPopup: action.payload,
      };
    },
  },
});

export const HealthInsuranceReducer = HealthInsuranceSlice.reducer;
export const HealthInsuranceSliceKey = HealthInsuranceSlice.reducerPath;
export const {
  setHiAllPolicyDetails,
  setHiSecondaryAllPolicyDetails,
  setHiAllPolicyInsuredDetails,
  setQuickActionMenuDetails,
  updateMedicalReportInlineFunClicked,
  updateMedicalReportDownloaded,
  setHiBackgroundImage,
  setShouldOpenHiMyServicesPopup,
} = HealthInsuranceSlice.actions;
